// extracted by mini-css-extract-plugin
module.exports = {"copy-container":"Copy_copy-container__2biB1","copy-icon":"Copy_copy-icon__FeRrf"};